import { styled } from '@mui/material';

import { useUserData } from '@app-velocity/libs/auth';

const UserMenu = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'nowrap',
  padding: '12px 16px',
  paddingRight: '0',
  gap: '27px',
  alignItems: 'center',
  cursor: 'pointer',
}));

const UserInfoContainer = styled('div')(() => ({
  display: 'flex',
  gap: '8px',
  flexWrap: 'nowrap',
}));

const UserInfo = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'nowrap',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}));

const Email = styled('span')(() => ({
  fontWeight: 700,
  fontSize: '12px',
  lineHeight: '16px',
  color: 'var(--color-general-grey-700)',
}));

export const UserPanel = () => {
  const { userEmail } = useUserData();

  return (
    <UserMenu>
      <UserInfoContainer>
        <UserInfo>
          <Email>{userEmail}</Email>
        </UserInfo>
      </UserInfoContainer>
    </UserMenu>
  );
};
